import { render, staticRenderFns } from "./categoryDialog.vue?vue&type=template&id=3a8b794e&scoped=true"
import script from "./categoryDialog.vue?vue&type=script&lang=js"
export * from "./categoryDialog.vue?vue&type=script&lang=js"
import style0 from "./categoryDialog.vue?vue&type=style&index=0&id=3a8b794e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b794e",
  null
  
)

export default component.exports